import { combineReducers } from 'redux'

import resultado from './detalhesOrdemCronologicaPagamento'

export default combineReducers({ resultado })
